import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { StoreUser } from "../../shared/StoreUser";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppConsts } from "../../shared/app-consts";
import { ResetPasswordModel } from "../../shared/ResetPasswordModel";
import { LoginUserRequestModel } from "../../shared/LoginUserRequestModel";
import { LoginUserResponseModel } from "../../shared/LoginUserResponseModel";
import { environment } from "../../../environments/environment";
import { CookieService } from 'ngx-cookie-service';
import { LocalUserDataModel } from '../../shared/models/localUserData.model';
import { BaseService } from "../base.service";
import * as _ from 'lodash';
import { switchMap, distinctUntilChanged, debounceTime } from "rxjs/operators";
import { Router } from "@angular/router";
import { ResetPasswordRequest } from "../../shared/ResetPasswordRequest";
import { SendCodeModel } from '@shared/security/send-code.model';
import { VerifyCodeModel } from '@shared/security/verify-code.model';
import { ConfirmEmailRequestModel } from '@shared/security/confirm-email-request.model';
import { SecurityQuestionRequest } from "@shared/security/security-question-request.model";
import { ConfirmChangeEmailRequestModel } from "@shared/security/confirm-changeEmail-request.model";
import { OperationResult } from "@shared/models/common/OperationResult";

@Injectable()
export class AuthenticationService extends BaseService {
  
  authenticationState = new BehaviorSubject(false);
  currentUser = new BehaviorSubject('');
  isLoginPage = new BehaviorSubject(false);
  sessionExpired = new BehaviorSubject<boolean>(false);
  sTimeout: number = 10 * 60 * 1000; // 10 min
  sessionTimeout: any;


  constructor(private http: HttpClient, private router: Router) {
    super();
  }

  signIn(response:any,email:string,rememberMe:any){
    
    let localUserData = new LocalUserDataModel();
    localUserData.FullName = response.FullName;
    localUserData.UserEMail = email;
    localUserData.RememberMe = rememberMe;
    localUserData.UserRoles = response.Roles;
    if(rememberMe)
    { 
      localStorage.setItem(AppConsts.REMEMBER_ME, rememberMe);
      localStorage.setItem(AppConsts.USER_MAIL, email);
    }
    else
    {
      localStorage.removeItem(AppConsts.REMEMBER_ME);
      localStorage.removeItem(AppConsts.USER_MAIL);
    }
    localUserData.IsAuthenticated = true;
    this.setXsrf(response.XsrfToken);
    this.setLocalUserData(localUserData);    
    sessionStorage.setItem("isResponsable", response.IsResponsableClient);
    this.authenticationState.next(true);
    this.currentUser.next(email);
    this.isLoginPage.next(false);
   }

   setSessionTimeout() {
    const date = new Date().getTime().toString();
    window.sessionStorage.setItem("lastActivity", date);
    this.sessionExpired.next(false);
    clearTimeout(this.sessionTimeout);
    window["InactiveUser"] = this.inactiveUser;
    window["endSession"] = this.endSession;
    window["sTimeout"] = this.sTimeout;
    window["getLocalUserData"] = this.getLocalUserData;
    window["expiredSession"] = this.sessionExpired;
    this.sessionTimeout = setTimeout(this.inactiveUser, this.sTimeout / 3);
  }

  endSession() {          
     let sessionExpire = window["expiredSession"] as BehaviorSubject<boolean>;    
     sessionExpire.next(true);    
   }

   inactiveUser() {
    const userData = window["getLocalUserData"]();
    const isAuthenticated =
      userData && userData != null && userData.IsAuthenticated;
    if (!isAuthenticated) return false;
    const lastActivity = parseInt(
      window.sessionStorage.getItem("lastActivity")
    );
    const currentTime = new Date().getTime();
    const timeLastActivity = lastActivity + parseInt(window["sTimeout"]);
    if (timeLastActivity <= currentTime) {
      window["endSession"]();
    } else {
      const diffTimeout = timeLastActivity - currentTime;
      this.sessionTimeout = setTimeout((res) => {
        window["InactiveUser"]();
      }, diffTimeout / 2);
    }
  }

  setXsrf(XsrfToken: string) {
    sessionStorage.setItem("XSRF-TOKEN", XsrfToken);
  }

  GetAntiforgery(): Observable<Object> {
    return this.http.get(environment.API_SERVICE_URL + "Security/antiforgery", this.getHttpHeader(false));
  }

  SendTokenResetPassword(resetPwdModel: ResetPasswordRequest) {
    return this.http.post(environment.API_SERVICE_URL + "account/sendmailforresetpassword", resetPwdModel, this.getHttpHeader(false));
  }

  login(credentials: LoginUserRequestModel): Observable<Object> {  
    if (credentials.Password === null || credentials.Email === null)
      throw "Please insert credentials";
    else {
      return this.http.post(environment.API_SERVICE_URL + "account/Login", credentials, this.getHttpHeader(false));
 
    };
  }

  logout() {
    let httpOptions = this.getHttpHeader();
    this.http.post(environment.API_SERVICE_URL + "account/LogOut", null, httpOptions).subscribe(() => {
      sessionStorage.removeItem(AppConsts.TOKEN_KEY);
      sessionStorage.removeItem("isResponsable");
      this.authenticationState.next(false);
      this.isLoginPage.next(true);
      this.router.navigate(['login']);
    }); 
  }

  IsAuthenticated() {
    const userData = this.getLocalUserData();
    return userData && userData != null && userData.IsAuthenticated;
  }


  register(credentials: StoreUser) {
    let httpOptions = this.getHttpHeader();

    if (
      credentials.Nom === null ||
      credentials.Prenom === null ||
      credentials.Password === null ||
      credentials.Email === null
    ) {
      throw "Merci de vérifier vos saisies.";
    } else {
      return this.http.post(
        environment.API_URL + "account/register",
        credentials
        , httpOptions
      );
    }
  }

  updateMySettings(credentials: StoreUser) {
    let httpOptions = this.getHttpHeader();

    return this.http.post(
      environment.API_URL + "account/updateSettings",
      credentials
      , httpOptions
    );
  }

  ConfirmEmail(model : ConfirmEmailRequestModel) { 
    let httpOptions = this.getHttpHeader();  
    return this.http.post( environment.API_SERVICE_URL + "account/confirmEmail", model, httpOptions );
  }

  SendPasswordResetLink(data: string) {
    let httpOptions = this.getHttpHeader();

    return this.http.post(environment.API_URL + "account/SendPasswordResetLink", JSON.stringify(data), httpOptions);
  }

  SendNewPassword(data: ResetPasswordModel) {
    let httpOptions = this.getHttpHeader();

    return this.http.post(environment.API_URL + "account/NewPassword", JSON.stringify(data), httpOptions);
  }

  getCurrentUser() {
    let httpOptions = this.getHttpHeader();

    return this.http.post(environment.API_URL + "account/getCurrentUser", null, httpOptions);
  }

  updateImage(image: any) {
    let httpOptions = this.getHttpHeader();

    return this.http.post(environment.API_URL + "account/updatePhoto", JSON.stringify(image), httpOptions);
  }

  logoff():Observable<any> {
    let httpOptions = this.getHttpHeader();

    const userData = this.getLocalUserData();
    return this.http.post(environment.API_URL + "account/LogOff", JSON.stringify(userData.UserEMail), httpOptions);
  }

  refreshToken() {
    let httpOptions = this.getHttpHeader(); 
    return this.http.post(environment.API_SERVICE_URL + "account/refreshTokenv2", null, httpOptions);
  } 

 getValidTwoFactorProviders(email:string){ 
   let httpOptions = this.getHttpHeader(); 
   return this.http.post(environment.API_SERVICE_URL + "account/GetValidTwoFactorProvidersAsync", JSON.stringify(email), httpOptions);
 }

 sendCodeTwofactor(model:SendCodeModel):Observable<any>{
  let httpOptions = this.getHttpHeader(); 
  return this.http.post(environment.API_SERVICE_URL + "account/SendTwoFactorTokenAsync", model, httpOptions) as Observable<any>;
 }

 verifyCodeTwofactor(model:VerifyCodeModel):Observable<any>{
  let httpOptions = this.getHttpHeader(); 
  return this.http.post(environment.API_SERVICE_URL + "account/VerifyCode", model, httpOptions) as Observable<any>;
 }

  getLocalUserData(): LocalUserDataModel {
    return JSON.parse(sessionStorage.getItem(AppConsts.TOKEN_KEY)) as LocalUserDataModel;
  }

  setLocalUserData(userData: LocalUserDataModel) {
    sessionStorage.setItem(AppConsts.TOKEN_KEY, JSON.stringify(userData));
  }

  hasPermission(roles: string[]) {
    const localUserData = this.getLocalUserData();
    return this.IsAuthenticated() && localUserData.UserRoles != null && _.intersection(localUserData.UserRoles, roles).length > 0;
  }

  IsResponsableClient():Observable<boolean> {
    let httpOptions = this.getHttpHeader(); 
    return this.http.get<boolean>(environment.API_SERVICE_URL + "coffrefort/verifyIfResponsableClient",httpOptions);
  }

  isValidResetPassword(model:ResetPasswordModel):Observable<any>{
    let httpOptions = this.getHttpHeader(); 
    return this.http.post(environment.API_SERVICE_URL + "account/isvalidresetpasswordtoken", model, httpOptions) as Observable<any>;
   }
   
   setNewPassword(model:ResetPasswordModel):Observable<any>{
    let httpOptions = this.getHttpHeader(); 
    return this.http.post(environment.API_SERVICE_URL + "account/setnewpassword", model, httpOptions) as Observable<any>;
   }

   sendmailforresetpassword(model:ResetPasswordRequest):Observable<OperationResult<boolean>>{
    let httpOptions = this.getHttpHeader(); 
    return this.http.post(environment.API_SERVICE_URL + "account/sendmailforresetpassword", model, httpOptions) as Observable<OperationResult<boolean>>;
   }

   addSecurityQuestion(model:SecurityQuestionRequest){
    let httpOptions = this.getHttpHeader(); 
    return this.http.post(environment.API_SERVICE_URL + "account/addSecurityQuestion", model, httpOptions) as Observable<any>;
   }

   editSecurityQuestion(model:SecurityQuestionRequest){
    let httpOptions = this.getHttpHeader(); 
    return this.http.post(environment.API_SERVICE_URL + "account/editSecurityQuestion", model, httpOptions) as Observable<any>;
   } 

   ConfirmUpdateEmail(model: ConfirmChangeEmailRequestModel) : Observable<boolean> {
    let httpOptions = this.getHttpHeader();  
    return this.http.post<boolean>( environment.API_SERVICE_URL + "account/confirmUpdateEmail", model, httpOptions );
  }
}
